<template>
  <div class="app">
    <div
      :class="[onecode == 1 ? 'form-group' : 'form-group xinzeng']"
      @click="clickTiao(onecode, Barcode)"
    >
      <img id="barcode" class="img" />
      <div id="qrcode" v-if="onecode === 1"></div>
      <span :class="[onecode == 1 ? 'smallNum' : 'bigNum']">{{
        onecode == 1 ? codeTextpass : codeText
      }}</span>
    </div>

    <div v-show="onecode == 1">
      <p class="add_warn">动态码定时更新，请勿截屏，以免影响正常使用</p>
      <p class="lines"></p>
      <div class="moneys">
        <div style="text-align:center">
          <p class="money_has">余额</p>
          <p class="money_num">￥{{ moneyNum }}</p>
        </div>
        <router-link to="/Recharge" class="money_save">充值</router-link>
      </div>
    </div>

    <loading v-if="load"></loading>
  </div>
</template>
<script>
import JsBarcode from "jsbarcode";
import QRCode from "qrcodejs2";
export default {
  name: "longcode",
  data() {
    return {
      codeTextpass: "",
      codeText: "",
      load: false,
      Barcode: "",
      moneyNum: 0,
      appcode: "",
      code: ""
    };
  },
  props: ["onecode"],
  mounted() {
    const companyID = localStorage.getItem("companyID");
    this.appcode = localStorage.getItem("appcode");
    this.code = localStorage.getItem("code");
    this.RequestVIP(
      `h5/vip/info?openID=${this.code}&CompanyID=${companyID}`,
      res => {
        this.moneyNum = Number(res.data.data.table1[0].Money).toFixed(2);
      },
      err => console.log(err)
    );
    this.Barcode = localStorage.getItem("Barcode");
    console.log(this.Barcode);
    this.ChangeCode(this.Barcode);
    this.qrcode();
  },
  methods: {
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 132,
        height: 132,
        text: this.Barcode // 二维码地址
      });
    },
    ChangeCode(val) {
      this.codeTextpass = val.substring(0, 4) + "*********查看数字";
      this.codeText =
        val.substring(0, 4) +
        " " +
        val.substring(4, 8) +
        " " +
        val.substring(8, 12) +
        " " +
        val.substring(12, 13);
      console.log(this.codeText);
      JsBarcode("#barcode", val, {
        format: "ean13",
        width: 4,
        displayValue: false,
        // background: this.onecode == 1 ? "" : "#f5f5f5",
        valid: function(valid) {}
      });
    },
    clickTiao(val, Barcode) {
      if (val == 1) {
        this.$router.push({
          path: "/CodeDetails"
        });
      }
    }
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  background: #fff;
}
.form-group {
  width: 100%;
  height: 200px;
  /* margin-top: 30px; */
  text-align: center;
  background: #fff;
}
.img {
  width: 96%;
}
.add_warn {
  width: 100%;
  text-align: center;
  font-size: 8px;
  line-height: 13px;
  color: #848484;
  background: url("/static/image/awenhao.png") 20px 0px no-repeat;
  background-size: 10px;
}
.smallNum {
  font-weight: bold;
  font-size: 11px;
  color: #212121;
}
.bigNum {
  font-weight: bold;
  font-size: 18px;
  color: #212121;
}
.xinzeng {
  /* left: -50px; */
  position: fixed;
  /* top: 36%; */
  /* margin-top: -50px; */
  transform: rotate(90deg);
  background: #fff;
  /* width: 100%;
  height: 100%; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 2;
  margin: auto;
  margin-left: -30px;
}
.lines {
  width: 100%;
  border-top: 1px dotted #9e9e9e;
  opacity: 0.4;
  margin-top: 10px;
}
.moneys {
  width: 100%;
  padding: 0 21px;
  display: flex;
  justify-content: space-between;
  color: #f2553d;
  box-sizing: border-box;
  margin-top: 11px;
}
.money_has {
  background: url("/static/image/money.png") 0px 2px no-repeat;
  background-size: 10px;
  font-size: 10px;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.money_num {
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}
.money_save {
  width: 50px;
  height: 25px;
  background: #ff6760;
  opacity: 1;
  border-radius: 3px;
  line-height: 25px;
  color: #fff;
  font-size: 11px;
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#qrcode {
  width: 100px;
  height: 100px;
  position: relative;
  z-index: 999999;
  margin: 3px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/longcode.vue